<script setup lang="ts">
import NewsCard from '@features/news/components/NewsCard/NewsCard.vue'

import { useNewsList } from '@features/news/composables/useNewsList'
import { NEWS_ROUTES } from '@features/news/constants'

const { news, currentPage, countPages, onChangeCurrentPage } =
  await useNewsList()
</script>

<template>
  <div
    id="newsListContainer"
    class="news-list-container"
    data-test-id="news-list-container"
  >
    <div class="news-list-container__list" data-test-id="news-list">
      <nuxt-link
        v-for="newsItem in news?.results"
        :key="newsItem.slug"
        :to="NEWS_ROUTES.detail(newsItem.slug)"
        class="news-list-container__news-link"
        data-test-id="news-link"
      >
        <news-card
          class="news-list-container__card"
          :news="newsItem"
          data-test-id="news-card"
        />
      </nuxt-link>
    </div>

    <the-pagination
      v-if="countPages"
      class="news-list-container__pagination"
      :model-value="currentPage"
      :total-pages="countPages"
      data-test-id="news-pagination"
      @update:model-value="onChangeCurrentPage"
    />
  </div>
</template>

<style scoped lang="scss">
.news-list-container {
  padding-bottom: 120px;

  &__list {
    display: grid;
    grid-template-columns: 100%;
    gap: 20px;
  }

  &__news-link {
    height: max-content;
    transition: 0.2s ease-in;

    &:hover {
      cursor: pointer;
      transform: translateY(5px);
    }
  }

  &__card {
    width: unset !important;
  }

  &__pagination {
    margin-top: 60px;
  }

  @include media($bp-tablet) {
    &__list {
      grid-template-columns: repeat(
        2,
        calc((100% - 40px) / 2)
      ); // ширина карточки в 2 колонки с учетом gap: 20px;
      gap: 20px;
    }
  }

  @include media($bp-desktop-mini) {
    &__list {
      grid-template-columns: repeat(
        3,
        calc((100% - 72px) / 3)
      ); // ширина карточки в 3 колонки с учетом column-gap: 36px;
      row-gap: 30px;
      column-gap: 36px;
    }

    &__pagination {
      margin-top: 80px;
    }
  }
}
</style>
